import { Component, Input } from '@angular/core';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-paypal-widget',
  templateUrl: './paypal-widget.component.html',
  styleUrls: ['./paypal-widget.component.scss'],
  standalone: true
})
export class PaypalWidgetComponent {
  @Input() amount!: number;
  @Input() clientId!: string;

  constructor(private browser: BrowserService) {}

  ngOnInit() {
    this.loadPaypalScript();
  }

  loadPaypalScript() {
    if (!this.browser.isBrowser) return;
    if (document.getElementById('paypal-sdk')) return;
    const script = document.createElement('script');
    script.id = 'paypal-sdk';
    script.src = `https://www.paypal.com/sdk/js?client-id=${this.clientId}&components=messages`;
    script.async = true;
    document.body.appendChild(script);
  }
}